const importAll = (r: any) => r.keys().map(r);
const images = importAll(require.context('./../_asset/casino/girl', false, /\.(png|jpe?g|svg)$/));

export default images;